module.exports = __webpack_public_path__ + "img/zhang-success.bc356c5f.png";